<template>
  <div class="detailsContainer">
    <section class="communication">
      <h2>拜访详情</h2>
      <ul>
        <li>
          <label>拜访人姓名：</label>
          <span>{{ detailsVal.user_name }}</span>
        </li>
        <li>
          <label>拜访员工：</label>
          <span>{{ detailsVal.name }}</span>
        </li>
        <li v-if="detailsVal.entry_info != ''">
          <label>在职信息：</label>
          <table class="jobStyle">
            <thead>
              <tr>
                <th>入职时间</th>
                <th>项目名</th>
                <th>岗位</th>
                <th>是否交保险</th>
                <th>备注</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in detailsVal.entry_info" :key="item.entry_id">
                <td>
                  {{
                    item.entry_time == ""
                      ? "---"
                      : item.entry_time.substring(0, 10)
                  }}
                </td>
                <td>{{ item.project_name }}</td>
                <td>
                  <span v-for="element in item.role_name" :key="element">{{
                    element
                  }}</span>
                </td>
                <td>
                  <p v-if="item.need_insure == 1">是</p>
                  <p v-else>否</p>
                </td>
                <td>{{ item.entry_remark }}</td>
              </tr>
            </tbody>
          </table>
        </li>
        <li>
          <label>拜访类型：</label>
          <p v-if="detailsVal.visit_type == 1">电话</p>
          <p v-else-if="detailsVal.visit_type == 2">面访</p>
          <p v-else>社交APP</p>
        </li>
        <li>
          <label>拜访目的：</label>
          <p v-if="detailsVal.purpose == 1">培训</p>
          <p v-else-if="detailsVal.purpose == 2">纠纷</p>
          <p v-else>回访</p>
        </li>
        <li>
          <label>附件：</label>
          <viewer
            v-if="detailsVal.enclosure_image != ''"
            :images="attachmentPic"
            class="attachment"
          >
            <img
              v-for="(item, k) in detailsVal.enclosure_image"
              :key="k"
              :src="item.url_info.url_thumb"
            />
          </viewer>
          <p v-else>无</p>
        </li>
      </ul>
    </section>
    <section
      class="communication"
      v-if="detailsVal.communicate_record_info != ''"
    >
      <h2>沟通记录：</h2>
      <ul>
        <li v-for="(item, o) in detailsVal.communicate_record_info" :key="o">
          <span>{{ item.update_time }}</span>
          <span v-show="item.detail.type == 1">面试#</span>
          <span v-show="item.detail.type == 2">拜访#</span>
          <span v-show="item.detail.type == 3">线上#</span>
          <span>{{ item.detail.user_name }}：</span>
          <span>{{ item.communicate }}</span>
        </li>
      </ul>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detailsVal: {},
      tagColor: [
        "pink",
        "blue",
        "purple",
        "orange",
        "red",
        "green",
        "cyan",
        "red",
        "pink",
        "orange"
      ],
      attachmentPic: []
    };
  },
  props: {
    details: {}
  },
  watch: {
    details() {
      this.detailsVal = this.details;
      // console.log(this.detailsVal )
      this.attachmentPic = [];
      this.detailsVal.enclosure_image == ""
        ? (this.attachmentPic = [])
        : this.detailsVal.enclosure_image.forEach(element => {
            this.attachmentPic.push(element.url_info.url);
          });
    }
  },
  mounted() {
    this.detailsVal = this.details;
  }
};
</script>
<style lang="less" scoped>
.detailsContainer {
  > .info {
    padding: 20px 4% 10px;
    border-bottom: 6px solid #f2f2f2;
    position: relative;
    .angle {
      position: absolute;
      right: 20%;
      top: 50px;
      img {
        height: 50px;
      }
    }
    h1 {
      font-size: 30px;
    }
    .basicInfo {
      margin: 10px 0 6px;
      span {
        font-size: 12px;
        color: #999;
        display: inline-block;
        padding: 0 6px;
      }
    }
    .tagStyle {
      display: flex;
      flex-direction: row;
      align-items: center;
      li {
        margin-right: 10px;
      }
    }
    .importantInfo {
      > li {
        // display: flex;
        // flex-direction: row;
        // align-items: center;
        margin-bottom: 2px;
        .address {
          display: inline-block;
          p,
          span {
            display: block;
            font-size: 14px;
          }
          span {
            color: #999;
            font-size: 12px;
          }
        }
        p,
        span,
        label {
          font-size: 14px;
          color: #666;
          vertical-align: top;
          display: inline-block;
        }
      }
      .disStyle {
        display: inline-block;
        margin-right: 30px;
      }
    }
  }
  .jobStyle {
    display: inline-block;
    vertical-align: top;
    th,
    td {
      font-size: 12px;
      font-weight: normal;
      border: 1px solid #ccc;
      padding: 4px 10px;
      text-align: left;
    }
    th {
      background: #fafafa;
      color: rgba(0, 0, 0, 0.85);
    }
  }
  .communication {
    padding: 10px 4%;

    h2 {
      font-weight: normal;
      margin: 0;
      line-height: 32px;
      font-size: 16px;
      border-bottom: 1px solid #ededed;
      margin-bottom: 10px;
    }
    ul {
      li {
        margin-bottom: 4px;
        > div,
        > p {
          display: inline-block;
        }
        span {
          font-size: 14px;
        }
        span:nth-child(2) {
          margin: 0 10px;
        }
      }
    }
  }
}
.attachment {
  vertical-align: top;
  img {
    border: 1px solid #f2f2f2;
    margin-right: 30px;
    margin-bottom: 20px;
  }
}
</style>
